export const propertyKindEnums = {
  mansion: "マンション",
  apartment: "アパート",
  detached_house: "戸建て",
  terraced_house: "テラスハウス、タウンハウス",
};
